<div class="modal-header">
  @if (status() !== SwapStatus.complete && status() !== SwapStatus.failed && (isStake || isWithdraw)) {
    <h4 class="modal-title text-center">
      {{ (isStake ? 'staking.claim_stake_title' : 'staking.withdraw_title') | translate }}
    </h4>
  }
  @if (status() == SwapStatus.not_started && !isStake && !isWithdraw) {
    <h4 class="modal-title text-center">{{
      'widget.claim_title' | translate }}</h4>
  }
  @if (status() == SwapStatus.in_progess && !isStake && !isWithdraw) {
    <h4 class="modal-title text-center">{{
      'staking.claim_inprogress_title' | translate }}</h4>
  }
  @if (status() == SwapStatus.complete && !isStake && !isWithdraw) {
    <h4 class="modal-title text-center">{{
      'staking.claim_success_title' | translate }}</h4>
  }
  @if (status() == SwapStatus.complete && isStake && !isWithdraw) {
    <h4 class="modal-title text-center">{{
      'staking.stake_transaction_success' | translate }}</h4>
  }
  @if (status() == SwapStatus.failed) {
    <h4 class="modal-title text-center">{{
      'staking.rejected' | translate }}</h4>
  }
</div>

@if (status() == SwapStatus.in_progess && isWithdraw) {
  <div class="modal-body text-center">
    <img src="/assets/images/popup-icons/progress.svg" loading="lazy" alt="failed" class="statusIcon" />
    <p class="text-center mb-3 font-sm-15 text-white">{{ 'staking.withdraw_inprogress' | translate }}</p>
  </div>
}

<!-- ========== claim and stake section =============== -->

@if (status() == SwapStatus.in_progess && isStake && !isWithdraw) {
  <div class="modal-body text-center">
    <img src="/assets/images/popup-icons/progress.svg" loading="lazy" alt="failed" class="statusIcon" />
    <p class="text-center mb-3 font-sm-15 text-white">{{ 'staking.claim_stake_desc' | translate }}</p>
  </div>
}

<!-- ========== normal claim section =============== -->

@if (status() == SwapStatus.not_started && !isStake && !isWithdraw) {
  <div class="modal-body text-center">
    <img src="/assets/images/popup-icons/progress.svg" loading="lazy" alt="failed" class="statusIcon" />
    <p class="text-center mb-3 font-sm-15 text-white">{{ 'widget.claim_help' | translate }}</p>
  </div>
}

@if (status() == SwapStatus.in_progess && !isStake && !isWithdraw) {
  <div class="modal-body text-center">
    <img src="/assets/images/popup-icons/progress.svg" loading="lazy" alt="failed" class="statusIcon" />
    <p class="text-center mb-3 font-sm-15 text-white">{{ 'staking.claim_inprogress' | translate }}</p>
  </div>
}

@if (status() == SwapStatus.complete) {
  <div class="modal-body text-center">
    <img src="/assets/images/popup-icons/success.svg" loading="lazy" alt="complete" class="statusIcon" />
    <div class="text-center mb-3 font-sm-15 text-white">{{ (isStake ? 'staking.stake_claim_success' : isWithdraw ?
      'staking.withdraw_success' : 'staking.claim_success') | translate }}</div>
    <a type="button" href="{{ lang && lang !== 'en' ? '/'+lang : ''  }}/staking" class="btn btn-primary fs-7 w-auto"
      (click)="modalRef.hide()">{{ 'misc.close' | translate }}</a>
  </div>
}

@if (status() == SwapStatus.failed) {
  <div class="modal-body text-center">
    <img src="/assets/images/popup-icons/error.svg" loading="lazy" alt="failed" class="statusIcon" />
    <div class="text-center mb-3 font-sm-15 text-white">{{ 'staking.transaction_rejected' | translate }}</div>
    <div class="footer">
      <button type="button" class="btn btn-primary fs-7 w-50" (click)="modalRef.hide()">{{ 'misc.close' | translate
        }}</button>
    </div>
  </div>
}
